import clsx from 'clsx';

import { Asset } from '~modules/media-library/model/Asset';
import { ViewVariant } from '~modules/media-library/model/ViewVariant';

type TeaserTextProps = Resolve<{
  asset: Asset;
  variant?: ViewVariant;
}>;

export function TeaserText({ asset, variant = ViewVariant.DEFAULT }: TeaserTextProps) {
  if (variant === ViewVariant.LIST || variant === ViewVariant.TILE_SMALL) return null;

  return (
    <div
      className={clsx(
        'ml--teaser-title',
        'w-3/6',
        'font-semibold text-base leading-snug overflow-hidden overflow-ellipsis',
        variant === ViewVariant.TILE_LARGE && 'mt-2',
        variant === ViewVariant.TILE_MEDIUM && 'm-2',
      )}
    >
      {asset.attributes.fileextension ? asset.attributes.fileextension : null}
      {asset.attributes.fileextension && asset.attributes.filesizeFormatted ? ', ' : null}
      {asset.attributes.filesizeFormatted ? asset.attributes.filesizeFormatted : null}
    </div>
  );
}
